import type { ReactNode } from 'react';
import { Icon } from './Icon.js';

export type BannerTone = 'info' | 'warn' | 'danger' | 'success';

const TONE_ICON: Record<BannerTone, React.FC<{ size?: number }>> = {
  info: Icon.Info,
  warn: Icon.Warn,
  danger: Icon.Warn,
  success: Icon.CheckCircle,
};

export interface BannerProps {
  readonly tone?: BannerTone;
  readonly title?: ReactNode;
  readonly children?: ReactNode;
  readonly action?: ReactNode;
  readonly testId?: string;
}

export function Banner({ tone = 'info', title, children, action, testId }: BannerProps): JSX.Element {
  const ToneIcon = TONE_ICON[tone];
  return (
    <div className={`banner ${tone}`} role={tone === 'danger' || tone === 'warn' ? 'alert' : 'status'} data-testid={testId}>
      <ToneIcon size={16} />
      <div style={{ flex: 1, minWidth: 0 }}>
        {title ? <div style={{ fontWeight: 600, marginBottom: children ? 2 : 0 }}>{title}</div> : null}
        {children}
      </div>
      {action ? <div>{action}</div> : null}
    </div>
  );
}
